// https://github.com/FlutterInt/fips-shared-protocols/blob/master/tourndef.h

enum TournFlagsServInt {
  TOURNFLAG_SERVINT_PLAYERLIST_MASK = 0x0003,
  TOURNFLAG_SERVINT_PLAYERLIST_NO = 0x0001,
  TOURNFLAG_SERVINT_PLAYERLIST_DIALUP = 0x0002,
  TOURNFLAG_SERVINT_BYES_NO = 0x0004,
  TOURNFLAG_SERVINT_AUTOREBUY = 0x0008,
  TOURNFLAG_SERVINT_FINTABLE_BCKGRN = 0x0010,
  TOURNFLAG_SERVINT_TCHIPS_AWARD = 0x0020,
  TOURNFLAG_SERVINT_AFFILIATE_FUNDED = 0x0040,
  TOURNFLAG_SERVINT_REMATCH = 0x0080,
  TOURNFLAG_SERVINT_EXPERIMENTAL3 = 0x0100,
  TOURNFLAG_SERVINT_SYNCBREAKS = 0x0200,
  TOURNFLAG_SERVINT_REDUCED_PUBLISH = 0x0400,
  TOURNFLAG_SERVINT_EXPERIMENTAL4 = 0x0800,
  TOURNFLAG_SERVINT_GENDERMALE = 0x1000,
  TOURNFLAG_SERVINT_GENDERFEMALE = 0x2000,
  TOURNFLAG_SERVINT_RETAINBOUNTIES = 0x4000,
  TOURNFLAG_SERVINT_DISPLAYHUBRACKET = 0x8000,
  TOURNFLAG_SERVINT_RECURRING_TOURN = 0x10000,
  TOURNFLAG_SERVINT_TARGET_FLIGHT = 0x20000,
  // TOURNFLAG_SERVINT_VOICE_TOURN = 0x40000,
  TOURNFLAG_SERVINT_CHATMON_FINALTBL_YES = 0x80000,
  TOURNFLAG_SERVINT_CHATMON_FINALTBL_NO = 0x100000,
  TOURNFLAG_SERVINT_BLITZ = 0x200000,
  TOURNFLAG_SERVINT_CHIPGRAPH = 0x400000, // TOURNFLAG_SERVINT_EXPERIMENTAL5 = 0x400000,
  TOURNFLAG_SERVINT_MULTIDBM = 0x800000,
  TOURNFLAG_SERVINT_ALLWINNERS = 0x1000000
}

export default TournFlagsServInt;
